import { generatePath } from 'react-router-dom';
import { API } from '@/constants/api';
import http from '@/http';
import { parse } from '@/utils';
import { alertError } from '@/utils/notification';

export async function uploadSlip({ file, id }) {
  try {
    const formData = new FormData();
    formData.append('payment_slip', file);
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };

    const url = generatePath(API.TRANSACTION.UPLOAD_SLIP, { id });
    const { status, data } = await http.post(url, formData, config);

    if (status === 200) {
      return {
        success: true,
        data: parse.camelize(data),
      };
    }
    return {
      success: false,
    };
  } catch (error) {
    if (error.response) {
      const { errorCode } = parse.camelize(error.response.data);
      alertError(errorCode);
    } else {
      alertError('APPLICATION_ERROR');
    }
    return {
      success: false,
    };
  }
}

export async function getTransactionDetail({ id }) {
  try {
    const url = generatePath(API.TRANSACTION.DETAIL, { id });
    const { status, data } = await http.get(url);
    if (status === 200) {
      return {
        success: true,
        data: parse.camelize(data),
      };
    }
    return {
      success: false,
      data: null,
    };
  } catch (error) {
    if (error.response) {
      const { errorCode } = parse.camelize(error.response.data);
      alertError(errorCode);
    } else {
      alertError('APPLICATION_ERROR');
    }
    return {
      success: false,
      data: null,
    };
  }
}
